import React from 'react';
import { Box, Stack } from '@mui/material';
import ProjectViewPath from '../../Views/ProjectView/ProjectViewPath';
import StyledGridToolbarContainer from './Styled/StyledGridToolbarContainer';
import { useParams } from 'react-router-dom';
import DataGridFilterButton from '../DataGridFilterButton/DataGridFilterButton';

/**
 * Custom toolbar for the DocTable component.
 */
export default ({ setFilterButtonEl, tableFor }: IDocTableToolbarProps) => {
    const { areaName } = useParams();

    if (areaName === 'import') {
        return <></>;
    }
    return (
        <StyledGridToolbarContainer sx={{ minHeight: '50px' }}>
            {tableFor === 'searchResults' ? (
                <Box
                    ref={setFilterButtonEl}
                    sx={{ display: 'flex', width: '100%', justifyContent: 'end', m: 1 }}
                >
                    <DataGridFilterButton />
                </Box>
            ) : (
                <>
                    <Stack
                        sx={{
                            flexGrow: 4,
                            pr: 1,
                            overflowX: 'auto',
                            flexWrap: 'nowrap',
                        }}
                    >
                        <ProjectViewPath />
                    </Stack>
                    <Box
                        sx={{ position: 'absolute', top: 0, right: 0 }}
                        ref={setFilterButtonEl}
                    ></Box>
                </>
            )}
        </StyledGridToolbarContainer>
    );
};

/**
 * Interface that describes the props for the DocTableToolbar component.
 */
export interface IDocTableToolbarProps {
    setFilterButtonEl: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;
    tableFor: 'searchResults' | 'selectedDocuments';
}
